import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Serif-italic pull-quote with an accent left-border and a faint accent tint —
 * the deck's `.quote-block` pattern. Used to carry a core positioning line in
 * the hero / about / Growth sections. Headlines-only serif (DM Serif Display).
 *
 * `accent` colour-codes the branch: amber = Enterprise, teal = Growth.
 * Theme-aware; light theme is the default.
 */

type Accent = 'enterprise' | 'growth';

const accentBorder: Record<Accent, string> = {
  enterprise: 'border-enterprise',
  growth: 'border-growth',
};

const accentTint: Record<Accent, string> = {
  enterprise: 'bg-enterprise/5',
  growth: 'bg-growth/5',
};

export interface QuoteBlockProps
  extends React.HTMLAttributes<HTMLQuoteElement> {
  accent?: Accent;
}

export function QuoteBlock({
  accent = 'enterprise',
  className,
  children,
  ...props
}: QuoteBlockProps) {
  return (
    <blockquote
      className={cn(
        'border-l-[3px] py-5 px-7 font-serif text-xl italic leading-snug text-slate-800 dark:text-slate-100 md:text-2xl',
        accentBorder[accent],
        accentTint[accent],
        className,
      )}
      {...props}
    >
      {children}
    </blockquote>
  );
}

export default QuoteBlock;
